import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://good-old-maps-api.fly.dev';

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Password reset confirmation
export const confirmPasswordReset = async (token: string, password: string) => {
  try {
    const response = await api.post('/api/auth/confirm-password-reset', {
      token,
      new_password: password,
    });
    return response.data;
  } catch (error: any) {
    // Extract meaningful error message from API response
    let errorMessage = 'Failed to reset password';
    
    if (error.response?.data) {
      if (error.response.data.detail && Array.isArray(error.response.data.detail)) {
        errorMessage = error.response.data.detail[0] || 'Validation error';
      } else if (error.response.data.detail && typeof error.response.data.detail === 'string') {
        errorMessage = error.response.data.detail;
      } else {
        errorMessage = error.response.data.message || 
                      error.response.data.error ||
                      error.response.data.msg ||
                      'Failed to reset password';
      }
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    throw new Error(errorMessage);
  }
};

// Request password reset
export const requestPasswordReset = async (email: string) => {
  try {
    const response = await api.post('/api/auth/reset-password', {
      email,
    });
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 
                        error.response?.data?.detail || 
                        error.response?.data?.error ||
                        error.message || 
                        'Failed to send reset email';
    throw new Error(errorMessage);
  }
};

// Account verification
export const verifyAccount = async (token: string, apiBaseUrl?: string) => {
  try {
    // Use custom API URL if provided, otherwise use default api instance
    const verifyApi = apiBaseUrl 
      ? axios.create({
          baseURL: apiBaseUrl,
          headers: {
            'Content-Type': 'application/json',
          },
        })
      : api;
    
    const response = await verifyApi.post('/api/auth/verify-token', {
      token,
    });
    return response.data;
  } catch (error: any) {
    // Extract meaningful error message from API response
    let errorMessage = 'Failed to verify account';
    
    if (error.response?.data) {
      if (error.response.data.detail && Array.isArray(error.response.data.detail)) {
        errorMessage = error.response.data.detail[0] || 'Verification failed';
      } else if (error.response.data.detail && typeof error.response.data.detail === 'string') {
        errorMessage = error.response.data.detail;
      } else {
        errorMessage = error.response.data.message || 
                      error.response.data.error ||
                      error.response.data.msg ||
                      'Failed to verify account';
      }
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    throw new Error(errorMessage);
  }
};



































